import { render, staticRenderFns } from "./PageStartInformation.vue?vue&type=template&id=928f6bac&scoped=true"
import script from "./PageStartInformation.vue?vue&type=script&lang=js"
export * from "./PageStartInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928f6bac",
  null
  
)

export default component.exports